export class EventNoteDTO {
  public text: string;
}